import Swiper from 'swiper'
import {Parallax, Pagination, Autoplay, EffectFade} from 'swiper/modules'
// import 'swiper/modules/effect-fade/effect-fade.scss'
import 'swiper/css/effect-fade'
import swiperTransitionGuard from '../../../../resources/js/utils/_swiper-transition-guard'

document.addEventListener('DOMContentLoaded', () => {
    const sliderWrappers = document.querySelectorAll('.mtt-product-slider')

    if (sliderWrappers.length > 0) {
        sliderWrappers.forEach(sliderWrapper => {
            const swiperElement = sliderWrapper.querySelector('.mtt-product-slider__swiper')
            const pagination = sliderWrapper.querySelector('.swiper-pagination-custom')
            const paginationTitles = sliderWrapper.querySelectorAll('[data-pagination-title]')

            const swiperOptions = {
                modules: [Parallax, Pagination, Autoplay, EffectFade],
                effect: 'fade',
                fadeEffect: {
                    crossFade: true
                },
                speed: 1200,
                spaceBetween: 100,
                slidesPerView: 1,
                loop: true,
                parallax: true,
                grabCursor: true,
                autoplay: {
                    delay: 6000,
                    disableOnInteraction: false
                },
                pagination: {
                    el: pagination,
                    type: 'bullets',
                    clickable: true,
                    renderBullet: (index, className) => {
                        const paginationTitle = paginationTitles[index].getAttribute('data-pagination-title')
                        return bulletMarkup(className, paginationTitle)
                    }
                }
            }

            const swiper = new Swiper(swiperElement, swiperOptions)

            // The parallax children inside a slide finish before the slide's own
            // fade does, and their bubbling transitionend swallows the one Swiper
            // needs to end the transition. Without this the slider locks up after
            // the first autoplay step.
            swiperTransitionGuard(swiper)

            // Autoplay starts counting during init, but the progress bar is a CSS
            // animation that does not start until the browser paints the bullets on
            // the next frame. On a busy page that gap is big enough for the first
            // slide to switch before its bar is full, so start the countdown on that
            // same frame and let the two run off the same clock.
            swiper.autoplay.stop()
            requestAnimationFrame(() => swiper.autoplay.start())

            // `slideChange` also fires for Swiper's internal loop bookkeeping, which
            // happens once just after init -- that would stretch the first slide's
            // progress bar to the longer duration while autoplay still runs on the
            // shorter one, so it appeared to jump early. `realIndexChange` only fires
            // when we genuinely move to another product.
            swiper.on('realIndexChange', () => swiperElement.classList.add('swiper-changed'))

            /*swiperElement.addEventListener('mouseenter', function () {
                swiper.autoplay.stop()
            })

            swiperElement.addEventListener('mouseleave', function () {
                swiper.autoplay.start()
            })*/
        })
    }

    function bulletMarkup(className, title) {
        return (
            `<div class="${className}">
                <div class="swiper-pagination-progress"></div>
                <div class="swiper-pagination-bullet__title">${title}</div>
            </div>`
        )
    }
})
